var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import Service from "./Service.js";
import debounce from "../utils/debounce.js";
class Resize extends Service {
  constructor() {
    super(...arguments);
    __publicField(this, "props", {
      width: window.innerWidth,
      height: window.innerHeight,
      ratio: window.innerWidth / window.innerHeight,
      orientation: "square"
    });
    __publicField(this, "handler");
  }
  init() {
    this.handler = debounce(() => {
      this.updateProps();
      this.trigger(this.props);
    }).bind(this);
    window.addEventListener("resize", this.handler);
    return this;
  }
  kill() {
    window.removeEventListener("resize", this.handler);
  }
  updateProps() {
    this.props.width = window.innerWidth;
    this.props.height = window.innerHeight;
    this.props.ratio = window.innerWidth / window.innerHeight;
    this.props.orientation = "square";
    if (this.props.ratio > 1) {
      this.props.orientation = "landscape";
    }
    if (this.props.ratio < 1) {
      this.props.orientation = "portrait";
    }
    if (this.breakpointElement) {
      this.props.breakpoint = this.breakpoint;
      this.props.breakpoints = this.breakpoints;
    } else {
      this.props.breakpoint = void 0;
      this.props.breakpoints = void 0;
    }
    return this.props;
  }
  get breakpointElement() {
    return document.querySelector("[data-breakpoint]");
  }
  get breakpoint() {
    return window.getComputedStyle(this.breakpointElement, "::before").getPropertyValue("content").replaceAll('"', "");
  }
  get breakpoints() {
    const breakpoints = window.getComputedStyle(this.breakpointElement, "::after").getPropertyValue("content").replaceAll('"', "");
    return breakpoints.split(",");
  }
}
let instance;
let resize;
function useResize() {
  if (!resize) {
    if (!instance) {
      instance = new Resize();
    }
    const add = instance.add.bind(instance);
    const remove = instance.remove.bind(instance);
    const has = instance.has.bind(instance);
    const props = instance.updateProps.bind(instance);
    resize = {
      add,
      remove,
      has,
      props
    };
  }
  return resize;
}
export {
  useResize as default
};


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
